import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiMethod } from '../../apimethods/api-method';
import { BatchSetAPIModel } from './batchset-model';
import { ActivatedRoute, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { DataParam, customfunctions } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
declare var $;

@Component({
  selector: 'app-batchset',
  templateUrl: './batchset.component.html',
  styleUrls: ['./batchset.component.css']
})
/** BatchSet component*/
export class BatchSetComponent implements OnInit {
  modelItem = new BatchSetAPIModel();
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  dataTable: any;
  title: string;
  BatchList: any;
  popUpButtonText: string;
  /** Article-Type ctor */

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <BatchSetAPIModel>data["BatchSetPage"];
        this.MainGridTable();
        this.LoadBatchList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }



  ngOnInit(): void {
    $('.tblArticleList').css('height', GlobalConstants.size.height - 180);
    ApiMethod.getBaseUrl();

    $("#ddlSearchBatch").select2({
      placeholder: "Select Batch", dropdownParent: "#divMainFilter"
    }); $("#ddlSearchBatch").val([]).trigger("change");

  }

  LoadBatchList(): void {
    ApiMethod.getMethod(this.modelItem.GetBatchNoList + "/" + localStorage.aPubID).subscribe(
      Response => {
        this.BatchList = Response.aBatchList;


        $("LoadingImagePopup").hide();
      },
      error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  //Grid Show 
  MainGridTable(loadType = '') {
    let filterLoadType = $('#TabulArticleList .active').attr('name');
    if (loadType != '') {
      filterLoadType = loadType;
    }

    var dataparam = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      ModuleName: "BatchSetModule",
      LoadType: filterLoadType,
      Batches: $('#ddlSearchBatch').val().toString()
    }
    $("#LoadingImage").show();
    ApiMethod.postMethod(this.modelItem.GetBatchSetList, dataparam).subscribe(
      Response => {
        this.dataSet = JSON.stringify(Response.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = Response.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 280);
        dataItem.modulename = 'BatchSetModule';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  ArticleList() {
    $('#btnPopupHRW').show();
    $("LoadingImagePopup2").show();
    $('#tblArticleList tbody tr').remove();
    $('#btnFinalDelivery').css("display", "none");
    $('#btnStartProcess').css("display", "none");
    ApiMethod.getMethod(this.modelItem.GetBatchArticleList + "/" + localStorage.aEID).subscribe(
      Response => {
        var aBatchDetail = Response.aBatchDetails;
        if (aBatchDetail.length > 0) {
          if (aBatchDetail[0].StartProcessDate == null) {
            $('#btnStartProcess').css("display", "block");
          }
          else if (aBatchDetail[0].FinalDeliveryRequestDate == null && aBatchDetail[0].FinalDeliveryDoneDate == null) {
            $('#btnFinalDelivery').css("display", "block");
          }
          else {
            $('#btnFinalDelivery').css("display", "none");
            $('#btnStartProcess').css("display", "none");
          }
        }
        var aItemList = Response.aArticleList;
        $.each(aItemList, function (e, val) {
          var trSNo = (e + 1);
          let tr = '<tr>';
          tr += '<td>' + trSNo + '</td>';
          tr += '<td>' + val.ArticleNo + '</td>';
          tr += '<td>' + GlobalConstants.FormatDate(val.ReceivedDate) + '</td>';
          tr += '<td>' + GlobalConstants.FromateDateWithTime(val.HighWareUploadStart) + '</td>';
          tr += '<td>' + GlobalConstants.FromateDateWithTime(val.HighWareUploadCompleted) + '</td>';
          tr += '<td><center>' + GlobalConstants.isNullCheck(val.HighwareUploadDuration) + '</center></td>';
          tr += '<td>' + GlobalConstants.FromateDateWithTime(val.S3UploadStart) + '</td>';
          tr += '<td>' + GlobalConstants.FromateDateWithTime(val.S3UploadCompleted) + '</td>';
          tr += '<td><center>' + GlobalConstants.isNullCheck(val.S3UploadDuration) + '</center></td>';

          tr += '</tr>';
          $('#tblArticleList tbody').append(tr);
        });
        $('#hrwArticleList').html('Total Articles : ' + aItemList.length);

        $("LoadingImagePopup2").hide();
      },
      error => {
        $("#LoadingImagePopup2").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  hideFinal() {
    $('#btnPopupHRW').hide();
  }
  FinalDelivery() {

    let articleList = $('#tblArticleList tbody tr').length;
    if (articleList == 0) {
      ngswal("Failed !", 'No Article Allocated !', "warning");
    }
    else {
      ngswal({
        title: "Are you confirm to final upload?",
        text: "Article Upload!",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, Proceed!",
        cancelButtonText: "No, Cancel!",
        closeOnConfirm: false,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (isConfirm) {
            $('#btnUploadConfirm').trigger("click");
          } else {
            ngswal("Cancelled", "Your cancelled the upload :)", "warning");
            return false;
          }
        });
    }
  }
  FinalDeliveryConfirm() {
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    var dataparam = {
      SNo: localStorage.aEID,
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.FinalDeliveryRequest, dataparam).subscribe(
      response => {

        $("#LoadingImagePopup").hide();
        if (response.status == 'Success') {
          $('#btnPopupHRW').hide();
          this.MainGridTable();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Added!",
            text: "Set added successfully!",
            showConfirmButton: true,
            timer: 1500
          });
          this.hide();

        }
        else {
          ngswal("Failed !", response.message, "warning");
          $("#LoadingImagePopup").hide();
        }

      },
      error => {
        ngswal("Failed !", error.Message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
  }
  // Show
  GetBatchNoList() {
    $("LoadingImagePopup").show();
    this.ClearData();
    $('#btnPopupartDetails').show();
    this.title = "Add";
    this.popUpButtonText = "Add";
    ApiMethod.getMethod(this.modelItem.GetBatchNoList + "/" + localStorage.aPubID).subscribe(
      Response => {
        this.BatchList = Response.aBatchList;


        $("LoadingImagePopup").hide();
      },
      error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "error");
      });

  }
  // Add Update 
  AddBatchSet(): void {
    //Validation 
    if ($('#ddlBatch').val() == null || $('#ddlBatch').val() == "0") {
      ngswal("Warning !", "Select Batch!", "warning");
    }
    else {
      //Getting Updated value
      $("#LoadingImagePopup").hide();

      var dataparam = {
        BatchNo: $('#ddlBatch').val(),
        LoginID: localStorage.aLoginID,
        PublisherID: localStorage.aPubID
      };

      ApiMethod.postMethod(this.modelItem.AddBatchSet, dataparam).subscribe(
        response => {

          $("#LoadingImagePopup").hide();
          if (response.status) {
            this.MainGridTable();
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Added!",
              text: "Set added successfully!",
              showConfirmButton: true,
              timer: 1500
            });
            this.hide();

          }
          else {
            ngswal("Failed !", response.message, "warning");
            $("#LoadingImagePopup").hide();
          }

        },
        error => {
          ngswal("Failed !", error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  // Delete Confirmation  Pop-up 
  DeleteArticleType() {

    ngswal({
      title: "Are you confirm to delete Article Type Details?",
      text: "Article Type Details deleted permenently!",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your data is safe :)", "warning");
          return false;
        }
      });
  }
  // Delete the Id
  DeleteConfirm() {
    $('#LoadingImagePopup').show();

    ApiMethod.getMethod(this.modelItem.DeleteArticleType + localStorage.aEID).subscribe(
      result => {
        this.MainGridTable();
        $("#LoadingImagePopup").hide();
        this.hide();
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Deleted Successfully!",
          text: result.deleteMsg,
          showConfirmButton: false,
          timer: 1500
        });
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  hide() {
    this.ClearData();
    $('#btnPopupartDetails').hide();
  }
  ClearData(): void {
    $('#txtArticleTypeName').val('');
    $('#Txt_DisplayOrder').val('');
    $('#txtArticleTypeCode').val('');
    $('#chkReopenCorrection').prop('checked', false);
    $('#chkPdfMerge').prop('checked', false);
    $('#chkNoNeedPDF').prop('checked', false);
    $('#chkDirectDelivery').prop('checked', false);

  }

  StartProcess() {
    let articleList = $('#tblArticleList tbody tr').length;
    if (articleList == 0) {
      ngswal("Failed !", 'No Article Allocated !', "warning");
    }
    else {
      ngswal({
        title: "Are you confirm to start process?",
        text: "Start Process!",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, Proceed!",
        cancelButtonText: "No, Cancel!",
        closeOnConfirm: false,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (isConfirm) {
            $('#btnStartConfirm').trigger("click");
          } else {
            ngswal("Cancelled", "Your cancelled the upload :)", "warning");
            return false;
          }
        });
    }
  }
  StartProcessConfirm() {
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    var dataparam = {
      SNo: localStorage.aEID,
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.BatchStartProcessRequest, dataparam).subscribe(
      response => {

        $("#LoadingImagePopup").hide();
        if (response.status == 'Success') {
          $('#btnPopupHRW').hide();
          this.MainGridTable();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Added!",
            text: "Set added successfully!",
            showConfirmButton: true,
            timer: 1500
          });
          this.hide();

        }
        else {
          ngswal("Failed !", response.message, "warning");
          $("#LoadingImagePopup").hide();
        }

      },
      error => {
        ngswal("Failed !", error.Message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
  }

  GetDataByActiveTab(tabName) {
    $("#ddlSearchBatch").val([]).change();
    this.MainGridTable(tabName);
  }
  getFiltered() {
    this.MainGridTable();
  }
  resetFilter() {
    $("#ddlSearchBatch").val([]).change();
    this.MainGridTable();
  }

}
